import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { NgIf, NgForOf, NgClass } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TooltipModule } from 'primeng/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { StorageService } from '@App/shared';
import { AppSettings } from '../../app.settings';

@Component({
  selector: 'app-user-profile-menu',
  templateUrl: './user-profile-menu.component.html',
  styleUrls: ['./user-profile-menu.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.Emulated,
  imports: [
    NgIf,
    NgForOf,
    NgClass,
    RouterLink,
    RouterLinkActive,
    TooltipModule,
    TranslateModule
  ]
})
export class UserProfileMenuComponent implements OnInit {
  @Input() menuItems: any[] = [];
  @Input() showHeader = true;
  @Output() itemClicked = new EventEmitter<any>();
  userInfo: any;
  defaultProfileUrl = AppSettings.DEFAULT_PROFILE_IMAGE_URL;

  constructor(private storageService: StorageService) {}

  private _isVisible = false;

  get isVisible(): boolean {
    return this._isVisible;
  }

  @Input() set isVisible(value: boolean) {
    this._isVisible = value;
    if (value) {
      this.loadUserInfo();
    }
  }

  ngOnInit() {
    this.loadUserInfo();
  }

  onItemClick(item: any) {
    this.itemClicked.emit(item);
  }

  private loadUserInfo() {
    const userDetailsString = this.storageService.getItem('profile');
    if (userDetailsString && typeof userDetailsString === 'string') {
      try {
        const userDetails = JSON.parse(userDetailsString);
        this.userInfo = {
          userFullName: userDetails.firstName + ' ' + userDetails.lastName,
          emailId: userDetails.emailId,
          profilePictureThumbnailUrl:
            userDetails.profilePictureThumbnailUrl || this.defaultProfileUrl
        };
      } catch (error) {
        console.error('Error parsing user details:', error);
      }
    }
  }
}
